module.exports = __webpack_public_path__ + "static/media/01-AXONOMETRICKY POHLAD_page-0001 (1) (2).114b8d78.jpg";